<template>
<div class="max_box">
  <!-- top -->
  <div class="top_box"><span class="top_span">语义管理</span></div>
  <el-container>
      <el-aside width="30%" style="border: 1px solid #ebebeb;overflow: hidden">
            <div style="color: #333;font-size: 12px;height:45px;background-color: #f5f5f5;padding:12px 0 0 10px;"> 关键词目录</div>
            <!--<el-tooltip class="item" effect="light" content="新增顶级分类" placement="top">-->
              <!--<el-button type="primary" size="mini" icon="el-icon-plus" circle @click="addTop()"></el-button>-->
            <!--</el-tooltip>-->
          <el-row style="margin-top:20px;margin-left:10px;" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '102110')">
            <el-input size="small" placeholder="请输入内容" clearable class="input-with-select" v-model="search_name" @keyup.enter.native="searchGroup()" style="width: 95%;">
              <el-button slot="append" icon="el-icon-search" @click="searchGroup()"></el-button>
            </el-input>
          </el-row>
          <!--<el-row>-->
            <!--<el-button type="primary" size="small" icon="el-icon-plus"  @click="addChild()">新增</el-button>-->
            <!--<el-button type="primary" size="small" icon="el-icon-edit" @click="editGroupName">编辑</el-button>-->
            <!--<el-button type="danger" size="small" icon="el-icon-delete"  @click="removeWordClassGroup()">删除</el-button>-->
          <!--</el-row>-->
          <el-row :style="'height:' + treeHeight" style="border: 1px solid #ebebeb;min-height: 200px" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '102110')">
              <el-scrollbar class="device-tree">
                <el-tree
                  class="filter-tree"
                  :data="data"
                  style="font-size: 14px;width: 100%"
                  node-key="bh"
                  :props="defaultProps"
                  :highlight-current="true"
                  :default-expanded-keys='expandedKey'
                  :allow-drop="allowDrop"
                  @node-drop="handleDrop"
                  draggable
                  ref="tree">
                  <div class="comp-tr-node" v-if="data.isEdit" slot-scope="{ node, data }" @mouseenter="mouseEnter(data)" @mouseleave="mouseLeave(data)">
                    <!-- 编辑状态 -->
                    <template>
                      <el-input
                        v-model="data.name"
                        :ref="data.bh"
                        maxlength="18"
                        @blur.stop="edit_sure(data,node.parent)"
                        @keyup.native.enter="$event.target.blur"
                        size="mini"
                      ></el-input>
                    </template>
                  </div>
                  <div class="comp-tr-node" v-else  @click="handleNodeClick(data)" slot-scope="{ node, data }" @mouseenter="mouseEnter(data)" @mouseleave="mouseLeave(data)">
                    <!-- 非编辑状态 -->
                    <template>
                      <!-- 名称： 新增节点增加class（is-new） -->
                      <span class="comp-tr-node--name">
                        <span class="iconfont iconweizhuanwenwenjian" aria-hidden="true"  v-if="data.bh.endsWith('L')">
                        </span>
                        <!--<i class="el-icon-document" v-if="data.bh.endsWith('L')">{{ node.label }}</i>-->
                        <span class="iconfont iconwenjianjia-dakai-copy" v-else></span>
                        {{ node.label }}
                      </span>
                      <!-- 默认坐席分组不可编辑 -->
                      <el-dropdown
                        placement="bottom-start"
                        v-show="data.isShow"
                        @command="handleCommand"
                        class="comp-tr-node--btns"
                      >
                      <span class="el-dropdown-link" v-if="(!data.parentId&&$qcAuthUtis.qcHasButtonAuth('aicc-qc', '102111'))||($qcAuthUtis.qcHasButtonAuth('aicc-qc', '102112')&&data.bh.split('.').length < 5)||
                      $qcAuthUtis.qcHasButtonAuth('aicc-qc', '102113')||(data.bh !== '1000L' && data.bh !== '1000' && $qcAuthUtis.qcHasButtonAuth('aicc-qc', '102114'))">
                        <i class="el-icon-more el-icon--right"></i>
                      </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item v-if="!data.parentId&&$qcAuthUtis.qcHasButtonAuth('aicc-qc', '102111')" command="top">
                            <el-tooltip class="item" effect="light" content="添加顶级节点" placement="right">
                              <el-button
                                type="text"
                                size="medium"
                                @click.stop="addTop()"
                              >
                                <svg class="icon color-primary" aria-hidden="true">
                                  <use xlink:href="#icontianjiawenjian" />
                                </svg>
                              </el-button>
                            </el-tooltip>
                          </el-dropdown-item>
                          <el-dropdown-item :command="'children'+data.id" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '102112')&&data.bh.split('.').length < 5">
                            <el-tooltip class="item" effect="light" content="添加子级节点" placement="right">
                              <el-button
                                type="text"
                                size="medium"
                                :ref="'children'+data.id"
                                @click.stop="addChild(node,data)"
                              >
                                <svg class="icon color-primary" aria-hidden="true">
                                  <use xlink:href="#icontianjia" />
                                </svg>
                              </el-button>
                            </el-tooltip>
                          </el-dropdown-item>
                          <el-dropdown-item :command="'edit'+data.id" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '102113')">
                            <el-tooltip class="item" effect="light" content="编辑节点" placement="right">
                              <el-button
                                type="text"
                                size="medium"
                                :ref="'edit'+data.id"
                                @click.stop="editGroupName(data)"
                              >
                                <svg class="icon color-primary" aria-hidden="true">
                                  <use xlink:href="#icontable-bianji" />
                                </svg>
                              </el-button>
                            </el-tooltip>
                          </el-dropdown-item>
                          <el-dropdown-item v-if="data.bh !== '1000L' && data.bh !== '1000' && $qcAuthUtis.qcHasButtonAuth('aicc-qc', '102114')" :command="'del'+data.id">
                            <el-tooltip class="item" effect="light" content="删除节点" placement="right">
                              <el-button
                                type="text"
                                size="medium"
                                :ref="'del'+data.id"
                                @click.stop="removeWordClassGroup(node,data)"
                              >
                                <svg class="icon color-danger" aria-hidden="true">
                                  <use xlink:href="#icontable-delete" />
                                </svg>
                              </el-button>
                            </el-tooltip>
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </template>
                  </div>
                </el-tree>
              </el-scrollbar>
          </el-row>
      </el-aside>
      <el-main style="padding-top: 0px;border-right:#e1e3e6 solid 1px;border-bottom:#e1e3e6 solid 1px;">
        <div style="border-top:#e1e3e6 solid 1px;margin-bottom:11px;"></div>
        <span style="border-left: 3px solid #337eff;margin-left: 15px;line-height: 20px"></span>
        <el-row>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-bind:key="item" v-for="(item) in group_list" >{{item}}</el-breadcrumb-item>
          </el-breadcrumb>
        </el-row>
        <el-row style="border-top:#e1e3e6 solid 1px;margin-top:11px;width:96%;margin-left:15px;"></el-row>
        <el-row v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '102120')">
          <span style="margin-left: 15px;font-size: 14px">
            关键词 <el-input size="small" style="width: 30%;margin-left: 10px;" clearable placeholder="请输入内容" v-model="keyWord_name" @keyup.enter.native="searchKeyWords"></el-input>
          </span>
          <span style="margin-left: 10px;font-size: 14px">
            同义词 <el-input size="small" style="width: 30%;margin-left: 10px;" clearable placeholder="请输入内容" v-model="keyWord_words" @keyup.enter.native="searchKeyWords"></el-input>
          </span><el-button style="margin-left: 10px;" size="small"  icon="el-icon-search" @click="searchKeyWords">搜索</el-button>
        </el-row>

        <el-row v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '102120')">
            <el-button style="margin-left: 15px;" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '102121')" size="small" type="info" icon="el-icon-plus" @click="addKeyWords" :disabled="disableButton">新增关键词</el-button>
            <el-button style="margin-left: 15px;" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '102122')" size="small" type="info" icon="el-icon-delete" @click="batchDelete" :disabled="disableButton">删除关键词</el-button>
            <el-button style="margin-left: 15px;" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '102123')" size="small" type="info" icon="el-icon-download" @click="downloadImportTemplate" :disabled="downloadImportDisableButton">下载模板</el-button>
              <el-upload
                ref="upload"
                class="upload-demo"
                style="display: inline-block;margin-left: 15px;"
                accept=".xls,.xlsx"
                :file-list="fileList"
                :data="upload_gid"
                :headers="headers"
                :disabled="disableButton"
                :on-success="handleSuccess"
                :show-file-list="false"
                :on-error="handleError"
                :action="uploadUrl">
                <el-button  size="small" type="info" slot="trigger" icon="el-icon-upload2" plain :disabled="disableButton" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '102124')">导入</el-button>
              </el-upload>
            <el-button style="margin-left: 15px;" size="small"  type="info" icon="el-icon-download" plain @click="exportKeyWords" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '102125')" :disabled="exportDisableButton">导出全部</el-button>
        </el-row>
        <el-row v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '102120')">
          <el-table
            :data="tableData"
            border
            :height="tableHeight"
            row-key="id"
            ref="multipleTable"
            style="width: 100%;border-left:0px;border-right:0px;min-height: 200px">
            <el-table-column
              type="selection"
              :reserve-selection="true"
              >
            </el-table-column>
            <el-table-column
              label="关键词"
              align="center"
              width="200%"
              >
              <template slot-scope="scope">
                <div>
                  <el-input size="small" v-if="scope.row.isEdit" clearable v-model="scope.row.name" @keyup.enter.native="saveKeyWords(scope.row)"></el-input>
                  <span v-else style="margin-left: 10px">{{ scope.row.name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="同义词"
              align="center"
              >
              <template slot-scope="scope" >
                <el-input size="small" v-if="scope.row.isEdit" clearable v-model="scope.row.words" @keyup.enter.native="saveKeyWords(scope.row)"></el-input>
                <div slot="reference" class="name-wrapper" v-else>
                  <div v-if="scope.row.words!==''&&scope.row.words!==null">
                    <el-tag :key="item" style="margin-right: 10px;margin-top: 5px;" v-for="(item) in scope.row.words.split(',')"  size="small">{{item}}</el-tag>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="125%">
              <template slot-scope="scope">
                <el-tooltip v-if="scope.row.isEdit" class="item" effect="light" content="保存" placement="top">
                  <el-button
                    type="text"
                    size="mini"
                    @click="saveKeyWords(scope.row)">
                    <svg class="icon color-primary" aria-hidden="true">
                      <use xlink:href="#iconduihao" />
                      <!--<use xlink:href="#iconchenggong" />-->
                      <!--<use xlink:href="#iconcheck-circle" />-->
                    </svg>
                  </el-button>
                </el-tooltip>
                <el-tooltip v-if="!scope.row.isEdit && $qcAuthUtis.qcHasButtonAuth('aicc-qc', '102131')" class="item" effect="light" content="编辑" placement="top">
                  <el-button
                    type="text"
                    size="mini"
                    @click="handleEdit(scope.row)">
                    <svg class="icon color-primary" aria-hidden="true">
                      <use xlink:href="#icontable-bianji" />
                    </svg>
                  </el-button>
                </el-tooltip>
                <el-tooltip v-if="scope.row.isEdit" class="item" effect="light" content="取消" placement="top">
                  <el-button
                    v-if="scope.row.isEdit"
                    type="text"
                    size="mini"
                    @click="cloneInput(scope.row,scope.$index)">
                    <svg class="icon color-danger" aria-hidden="true">
                      <use xlink:href="#iconclose" />
                      <!--<use xlink:href="#iconshibai" />-->
                      <!--<use xlink:href="#iconchahao" />-->
                    </svg>
                  </el-button>
                </el-tooltip>
                <el-tooltip v-if="!scope.row.isEdit && $qcAuthUtis.qcHasButtonAuth('aicc-qc', '102132')" class="item" effect="light" content="删除" placement="top">
                  <el-button
                    type="text"
                    size="mini"
                    @click="handleDelete(scope.row.id)">
                    <svg class="icon color-danger" aria-hidden="true">
                      <use xlink:href="#icontable-delete" />
                    </svg>
                  </el-button>
                </el-tooltip>
                <el-tooltip v-if="!scope.row.isEdit && $qcAuthUtis.qcHasButtonAuth('aicc-qc', '102133')" class="item" effect="light" content="移动分类" placement="top">
                  <el-button
                    size="mini"
                    type="text"
                    @click="transferGroup(scope.row.id,scope.row.name)">
                    <svg class="icon color-primary" aria-hidden="true">
                      <use xlink:href="#iconopen-arrow" />
                    </svg>
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <!-- page -->
          <Page v-bind:init_item="pageBuild" @currentPage="currentPage"/>
          <div style="width: auto;font-size: 12px;color: #666;margin-left: 10px;margin-top: 10px">*添加同义词时，不同的同义词请用“，”分割开。</div>
        </el-row>
      </el-main>
  </el-container>
  <el-dialog
    title="移动关键词"
    :visible.sync="dialogVisible"
    @closed="transferDialogClose"
    width="32%">
    <div style="height:260px;margin-top:30px;">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="关键词">
        <el-input  :disabled="true" v-model="form.name" style="width:85%;"></el-input>
      </el-form-item>
      <el-form-item label="分类">
        <el-cascader
          width="85%"
          :options="options"
          :props="customProps"
          v-model="form.groupId"
          :show-all-levels="false"
          clearable></el-cascader>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer" style="text-align: center;margin-top:15%;">
      <el-button size="small" @click="transferDialogClose">取 消</el-button>
      <el-button size="small" type="primary" @click="transferDialogASave">确 定</el-button>
    </div>
    </div>
  </el-dialog>
</div>
</template>

<script>
import { queryWordClassGroup, saveWordClassGroup, searchKeyWord, deleteSemanticManagement, updateSemanticManagement, deleteKeyWord, updateKeyWord, saveKeyWord, batchDeleteKeyWord, exportKeyWords, downloadTemplate, moveKeyWord } from '@/api/qc/semanticManagement.js'
import Page from '@/views/qc/public/PageComponent'
import '@/assets/icon/qc/iconfont.css'
export default {
  name: 'semanticManagement',
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  components: {
    Page
  },
  created() {
    window.addEventListener('resize', this.treeChange)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.treeChange)
  },
  data: function () {
    return {
      treeHeight: `${document.documentElement.clientHeight}` - 295 + 'px',
      tableHeight: `${document.documentElement.clientHeight}` - 388 + 'px',
      filterText: '',
      showInput: false,
      disableButton: true,
      exportDisableButton: true,
      downloadImportDisableButton: false,
      data_id: [],
      group_list: [],
      data_r_id: [],
      old_keywords_name: '',
      old_keywords_words: '',
      upload_gid: { groupId: '' },
      headers: { Authorization: this.getToken(), 'X-TENANT-ID': this.getCTenantId() },
      uploadUrl: window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_QC_SERVICE') + '/mgr/wordClass/importKeyWords',
      search_name: '',
      old_search_name: '',
      data: [],
      selectTreeData: [],
      expandedKey: [],
      fileList: [],
      keyWord_name: '',
      keyWord_words: '',
      edit_true_bh: '',
      edit_old_name: '',
      keyWord_list: [],
      dialogVisible: false,
      pageBuild: {
        page_size: 10,
        total: 0,
        currentPage: 1
      },
      form: {
        name: '',
        groupId: '',
        id: ''
      },
      options: [],
      customProps: {
        label: 'name',
        children: 'children',
        value: 'id',
        checkStrictly: true
      },
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      bool: false,
      editable: [],
      tableData: []
    }
  },
  methods: {
    searchGroup: function () {
      var that = this
      if (that.search_name.length > 0) {
        if (that.search_name !== that.old_search_name) {
          that.data_id = []
        }
        if (that.data_id.length === 0) {
          that.data.forEach(data => {
            var label = data.name.replace(/\s*/g, '')
            if (label.indexOf(that.search_name) !== -1) {
              that.data_id.push(data.bh)
            }
            if (data.children.length > 0) {
              that.recursionGroupBh(data, that.data_id)
            }
          })
          that.old_search_name = that.search_name
        }
        if (that.data_id.length > 0) {
          var id = that.data_id[0]
          that.$refs.tree.setCurrentKey(id)
          that.$refs.tree.store.nodesMap[id].expanded = true
          that.parentNodesChange(that.$refs.tree.store.nodesMap[id])
          that.data_id.splice(0, 1)
        }
      } else {
        window.qcMessage({ type: 'warning', text: '请输入内容' })
      }
    },
    recursionGroupBh(node, bhs) {
      var that = this
      node.children.forEach(data => {
        var label = data.name.replace(/\s*/g, '')
        if (label.indexOf(that.search_name) !== -1) {
          bhs.push(data.bh)
        }
        if (data.children.length > 0) {
          that.recursionGroupBh(data, bhs)
        }
      })
    },
    addTop() {
      var that = this
      // var data = that.$refs.tree.getCurrentNode()
      var newBh = ''
      if (that.data.length > 0) {
        newBh = (+that.data[that.data.length - 1].bh.replace('L', '') + 1) + 'L'
      } else {
        newBh = '1000L'
      }
      var top = { bh: newBh, children: [], name: '' }
      that.data.push(top)
      that.editGroupName(top)
    },
    clickWordClassGroup(id) {
      var that = this
      that.$refs.tree.setCurrentKey(id)
      if (that.$refs.tree.store.nodesMap[id]) {
        that.$refs.tree.store.nodesMap[id].expanded = true
      }
      that.parentNodesChange(that.$refs.tree.store.nodesMap[id])
    },
    addChild(node, data) {
      var that = this
      // var data = that.$refs.tree.getCurrentNode()
      var parentBh = ''
      if (data == null) {
        window.qcMessage({ type: 'warning', text: '请选择分组！' })
        return false
      }
      var newBh = ''
      if (data.children.length === 0) {
        parentBh = data.bh.replace('L', '')
        data.bh = parentBh
        newBh = parentBh + '.1000L'
      } else {
        parentBh = data.bh
        var arr = data.children[data.children.length - 1].bh.replace('L', '').split('.')
        var bbh = parseInt(arr[arr.length - 1]) + 1
        newBh = data.bh + '.' + bbh + 'L'
      }
      var newChild = { bh: newBh, name: '', parentBh: parentBh, parentId: data.id, children: [] }
      if (!data.children) {
        this.$set(data, 'children', [])
      }
      node.expanded = true
      data.children.push(newChild)
      that.$nextTick(() => {
        that.editGroupName(newChild)
      })
    },
    removeWordClassGroup(node, data) {
      var that = this
      // var data = that.$refs.tree.getCurrentNode()
      if (data == null) {
        window.qcMessage({ type: 'warning', text: '请选择分组！' })
        return false
      }
      if (data.bh === '1000L' || data.bh === '1000') {
        window.qcMessage({ type: 'warning', text: '初始根分组不能删除！' })
      } else {
        var ids = []
        ids.push(data.id)
        if (data.children.length > 0) {
          that.recursionGroup(data, ids)
        }
        var preBh = null
        var preId = null
        if (data.parentBh) {
          if (node.parent.childNodes.length < 2) {
            preBh = data.parentBh + 'L'
            preId = data.parentId
          }
        }
        window.qcMessageBox({
          title: '',
          text: '确定要删除吗？',
          f: function () {
            deleteSemanticManagement({ ids: ids, parentBh: preBh, parentId: preId }).then(res => {
              // that.queryWordClassGroup(null)
              if (res.data.code === 2000) {
                const parent = node.parent
                const children = parent.data.children || parent.data
                const index = children.findIndex(d => d.id === data.id)
                children.splice(index, 1)
                if (children.length === 0) {
                  that.$nextTick(() => {
                    if (preBh) {
                      that.$refs.tree.store.nodesMap[preBh.replace('L', '')].data.bh = data.parentBh + 'L'
                      that.$refs.tree.store.nodesMap[preBh] = that.$refs.tree.store.nodesMap[preBh.replace('L', '')]
                    }
                  })
                }
                if (that.selectTreeData.id === data.id) {
                  that.tableData = []
                  that.group_list = []
                } else {
                  that.handleNodeClick(that.selectTreeData)
                }
                window.qcMessage({ type: 'success', text: res.data.msg })
              } else {
                window.qcMessage({ type: 'warning', text: res.data.msg })
              }
            }).catch(res => {
              window.qcMessage({ type: 'warning', text: '请求错误，请稍后再试' })
            })
          },
          c: function () { return false }
        })
      }
    },
    allowDrop(draggingNode, dropNode, type) {
      if (draggingNode.data.parentBh === dropNode.data.parentBh) {
        return type === 'inner'
      } else {
        return true
      }
    },
    recursionGroup(data, ids) {
      var that = this
      if (data.children.length > 0) {
        data.children.forEach(item => {
          ids.push(item.id)
          that.recursionGroup(item, ids)
        })
      }
    },
    handleNodeClick(data) {
      var that = this
      that.selectTreeData = data
      that.group_list = []
      that.upload_gid.groupId = data.id
      var str = ''
      for (let i = 0; i < data.bh.split('.').length; i++) {
        if (i > 0) {
          str = str + '.' + data.bh.split('.')[i]
        } else {
          str = data.bh.split('.')[i]
        }
        that.group_list.push(that.$refs.tree.store.nodesMap[str].data.name)
      }
      that.queryKeyWord(that.pageBuild.page_size, 1, data.bh)
      that.disableButton = false
      that.exportDisableButton = false
    },
    currentPage(currentPage) {
      var that = this
      that.pageBuild.currentPage = currentPage
      var bh = that.$refs.tree.getCurrentNode().bh
      that.queryKeyWord(that.pageBuild.page_size, currentPage, bh)
    },
    searchKeyWords() {
      var data = this.$refs.tree.getCurrentNode()
      if (data == null) {
        window.qcMessage({ type: 'warning', text: '请选择分组！' })
        return false
      }
      this.currentPage(1)
    },
    queryKeyWord(limit, page, bh) {
      var that = this
      var params = { page: page, limit: limit, name: that.keyWord_name, words: that.keyWord_words, bh: bh }
      searchKeyWord(params).then(res => {
        if (res.data.code === 2000) {
          that.tableData = res.data.data.root
          that.pageBuild.total = res.data.data.totalProperty
        } else {
          window.qcMessage({ type: 'warning', text: '请求错误，请稍后再试' })
        }
      })
    },
    handleEdit(_data) {
      // 编辑节点
      // 设置编辑状态
      if (!_data.isEdit) {
        this.$set(_data, 'isEdit', true)
      }
      this.old_keywords_name = _data.name
      this.old_keywords_words = _data.words
    },
    cloneInput(_data, index) {
      var that = this
      this.add_tableLine = false
      // 设置编辑状态
      if (_data.isEdit) {
        that.$set(_data, 'isEdit', false)
        if (!_data.id) {
          that.tableData.splice(index, 1)
        } else {
          _data.name = that.old_keywords_name
          _data.words = that.old_keywords_words
        }
      }
    },
    addKeyWords() {
      var that = this
      var data = that.$refs.tree.getCurrentNode()
      if (data == null) {
        window.qcMessage({ type: 'warning', text: '请选择分组！' })
        return false
      }
      var newLine = {
        name: '',
        words: '',
        isEdit: true
      }
      this.tableData.unshift(newLine)
    },
    saveKeyWords(_data) {
      var that = this
      var data = that.$refs.tree.getCurrentNode()
      if (data == null) {
        window.qcMessage({ type: 'warning', text: '请选择分组！' })
        return false
      }
      if (_data.name === '') {
        window.qcMessage({ type: 'warning', text: '请输入关键词' })
        return false
      }
      // if (_data.words === '') {
      //   window.qcMessage({ type: 'warning', text: '请输入同义词' })
      //   return false
      // }
      _data.words = _data.words.replace(/，/g, ',')
      if (_data.words.startsWith(',')) {
        _data.words = _data.words.replace(/^,/gi, '')
      }
      if (_data.words.endsWith(',')) {
        _data.words = _data.words.replace(/,$/gi, '')
      }
      _data.words = _data.words.replace(/\s+/g, '')
      _data.name = _data.name.replace(/\s+/g, '')
      // _data.words = _data.words.replace(/[`～*~!@#$%^&*()_\-+=<>?:"{}|./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’。、]/g, '')
      // _data.name = _data.name.replace(/[`～*~!@#$%^&*()_\-+=<>?:"{}|./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’。、]/g, '')
      var strs = _data.words.split(',')
      var arry = []
      var word = ''
      strs.forEach((str, i) => {
        if (str.length > 0) {
          arry.push(str)
        }
      })
      arry.forEach((str, i) => {
        if (i > 0) {
          word = word + ',' + str
        } else {
          word = str
        }
      })
      _data.words = word
      var params = { name: _data.name, words: _data.words }
      // 判断新增还是修改
      if (_data.id) {
        // 判断是否修改了关键词或同义词
        if (that.old_keywords_name === _data.name && that.old_keywords_words === _data.words) {
          // 设置编辑状态
          if (_data.isEdit) {
            that.$set(_data, 'isEdit', false)
          }
          return false
        }
        params.id = _data.id
        updateKeyWord(params).then(res => {
          if (res.data.code === 2000) {
            window.qcMessage({ type: 'success', text: res.data.msg })
          } else {
            window.qcMessage({ type: 'warning', text: res.data.msg })
          }
          // 设置编辑状态
          if (_data.isEdit) {
            that.$set(_data, 'isEdit', false)
          }
          that.currentPage(1)
        })
      } else {
        params.wordClassGroupId = that.$refs.tree.getCurrentNode().id
        saveKeyWord(params).then(res => {
          if (res.data.code === 2000) {
            _data.id = res.data.data
            // 设置编辑状态
            if (_data.isEdit) {
              that.$set(_data, 'isEdit', false)
            }
            window.qcMessage({ type: 'success', text: res.data.msg })
          } else {
            window.qcMessage({ type: 'warning', text: res.data.msg })
          }
          // that.currentPage(1)
          this.tableData.splice(10, 1)
        })
      }
    },
    batchDelete() {
      var that = this
      var data = that.$refs.tree.getCurrentNode()
      if (data == null) {
        window.qcMessage({ type: 'warning', text: '请选择分组！' })
        return false
      }
      var sel = that.$refs.multipleTable.selection
      if (sel.length === 0) {
        window.qcMessage({ type: 'warning', text: '请勾选关键词！' })
        return false
      }
      var ids = []
      sel.forEach(item => {
        ids.push(item.id)
      })
      window.qcMessageBox({
        title: '',
        text: '确定要删除吗？',
        f: function () {
          batchDeleteKeyWord({ ids: ids }).then(res => {
            if (res.data.code === 2000) {
              window.qcMessage({ type: 'success', text: res.data.msg })
            } else {
              window.qcMessage({ type: 'warning', text: res.data.msg })
            }
            that.currentPage(1)
          })
        },
        c: function () { return false }
      })
    },
    handleDelete(ida) {
      var that = this
      window.qcMessageBox({
        title: '',
        text: '确定要删除吗？',
        f: function () {
          deleteKeyWord({ id: ida }).then(res => {
            if (res.data.code === 2000) {
              window.qcMessage({ type: 'success', text: res.data.msg })
            } else {
              window.qcMessage({ type: 'warning', text: res.data.msg })
            }
            that.currentPage(1)
          })
        },
        c: function () { return false }
      })
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      var that = this
      var params = {}
      params.id = draggingNode.data.id
      // 判断被移动的节点是否是顶级节点
      if (draggingNode.data.parentId) {
        params.oldParentId = draggingNode.data.parentId
        if (that.$refs.tree.store.nodesMap[draggingNode.data.parentBh].childNodes.length > 0) {
          params.oldParentBh = null
        } else {
          params.oldParentBh = draggingNode.data.parentBh + 'L'
        }
      } else {
        params.oldParentId = null
        params.oldParentBh = null
      }
      var oldBh = draggingNode.data.bh
      if (dropNode.parent.data.length > 1) {
        if (dropType === 'inner') {
          // 将本节点转移到顶级节点下
          params.parentId = dropNode.data.id
          if (dropNode.data.bh.endsWith('L')) {
            params.parentBh = dropNode.data.bh.replace('L', '')
          } else {
            params.parentBh = null
          }
          if (oldBh.endsWith('L')) {
            params.bh = dropNode.data.bh.replace('L', '') + '.' + (1000 + dropNode.data.children.length) + 'L'
          } else {
            params.bh = dropNode.data.bh.replace('L', '') + '.' + (1000 + dropNode.data.children.length)
          }
        } else {
          // 将本节点修改成顶级节点
          params.parentId = null
          params.parentBh = null
          if (oldBh.endsWith('L')) {
            params.bh = 1000 + dropNode.parent.data.length + 'L'
          } else {
            params.bh = 1000 + dropNode.parent.data.length
          }
        }
      } else {
        // 将本节点转移到其他节点下
        if (dropType === 'inner') {
          params.parentId = dropNode.data.id
          if (dropNode.data.bh.endsWith('L')) {
            params.parentBh = dropNode.data.bh.replace('L', '')
          } else {
            params.parentBh = null
          }
          if (oldBh.endsWith('L')) {
            params.bh = dropNode.data.bh.replace('L', '') + '.' + (1000 + dropNode.data.children.length) + 'L'
          } else {
            params.bh = dropNode.data.bh.replace('L', '') + '.' + (1000 + dropNode.data.children.length)
          }
        } else {
          params.parentId = dropNode.parent.data.id
          if (dropNode.parent.data.bh.endsWith('L')) {
            params.parentBh = dropNode.parent.data.bh.replace('L', '')
          } else {
            params.parentBh = null
          }
          if (oldBh.endsWith('L')) {
            params.bh = dropNode.parent.data.bh.replace('L', '') + '.' + (1000 + dropNode.parent.data.children.length) + 'L'
          } else {
            params.bh = dropNode.parent.data.bh.replace('L', '') + '.' + (1000 + dropNode.parent.data.children.length)
          }
        }
      }
      params.children = []
      that.recursionUpdateGroup(draggingNode.data, params.children, oldBh, params.bh)
      updateSemanticManagement(JSON.stringify(params)).then(res => {
        if (res.data.code === 2000) {
          window.qcMessage({ type: 'success', text: res.data.msg })
        } else {
          window.qcMessage({ type: 'success', text: res.data.msg })
        }
        that.queryWordClassGroup(that.selectTreeData)
      }).catch(res => {
        that.queryWordClassGroup(that.selectTreeData)
      })
    },
    recursionUpdateGroup(data, childe, oldBh, newBh) {
      var that = this
      if (data.children.length > 0) {
        data.children.forEach(item => {
          var dx = {}
          dx.id = item.id
          dx.bh = newBh + item.bh.replace(oldBh, '')
          childe.push(dx)
          that.recursionUpdateGroup(item, childe, oldBh, newBh)
        })
      }
    },
    parentNodesChange(node) {
      var that = this
      if (node.parent) {
        for (const key in node) {
          if (key === 'parent') {
            node[key].expanded = true
            that.parentNodesChange(node[key])
          }
        }
      }
    },
    transferDialogClose() {
      var that = this
      that.dialogVisible = false
      that.data_list = []
    },
    transferDialogASave() {
      var that = this
      var gid = that.form.groupId[that.form.groupId.length - 1]
      var params = { id: that.form.id, wordClassGroupId: gid }
      moveKeyWord(params).then(res => {
        if (res.data.code === 2000) {
          window.qcMessage({ type: 'success', text: res.data.msg })
        } else {
          window.qcMessage({ type: 'warning', text: res.data.msg })
        }
        that.dialogVisible = false
        var data = that.$refs.tree.getCurrentNode()
        that.queryKeyWord(that.pageBuild.page_size, 1, data.bh)
        that.data_list = []
      })
    },
    transferGroup(id, name) {
      var that = this
      that.options = that.data
      that.form.id = id
      that.form.name = name
      that.form.groupId = that.$refs.tree.getCurrentNode().id
      that.dialogVisible = true
    },
    transferGroupRecursion(data, arr) {
      var that = this
      if (data.children.length > 0) {
        data.children.forEach(item => {
          arr.push(item)
          that.transferGroupRecursion(item, arr)
        })
      }
    },
    queryWordClassGroup(data) {
      var that = this
      queryWordClassGroup().then(res => {
        that.data = res.data.data
        that.$nextTick(() => {
          if (data != null) {
            that.clickWordClassGroup(data.bh)
          }
        })
      }).catch(res => {

      })
    },
    handleSuccess (response, file, fileList) {
      if (response.code === 2000) {
        window.qcMessage({ type: 'success', text: response.msg })
      } else {
        window.qcMessage({ type: 'warning', text: response.msg })
      }
      this.fileList = []
      this.currentPage(1)
    },
    handleError (err) {
      window.qcMessage({ type: 'warning', text: err.msg })
    },
    getToken() {
      return localStorage.getItem('Authorization')
    },
    // 获取租户id
    getCTenantId() {
      return localStorage.getItem('X-TENANT-ID')
    },
    treeChange() {
      var that = this
      that.$nextTick(() => {
        that.treeHeight = `${document.documentElement.clientHeight}` - 295 + 'px'
        that.tableHeight = `${document.documentElement.clientHeight}` - 388 + 'px'
      })
    },
    exportKeyWords() {
      var that = this
      that.exportDisableButton = true
      var data = that.$refs.tree.getCurrentNode()
      if (data == null) {
        window.qcMessage({ type: 'warning', text: '请选择分组！' })
        return false
      }
      var params = { bh: data.bh, name: that.keyWord_name, words: that.keyWord_words }
      exportKeyWords(params).then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
        const fileName = '语义管理关键词' + '(' + (new Date()).valueOf() + ').xlsx'
        this.exportExcel(blob, fileName)
      })
      setTimeout(function () {
        that.exportDisableButton = false
      }, 2000)
    },
    downloadImportTemplate() {
      var that = this
      that.downloadImportDisableButton = true
      downloadTemplate().then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
        const fileName = '关键词导入模板' + '(' + (new Date()).valueOf() + ').xlsx'
        this.exportExcel(blob, fileName)
      })
      setTimeout(function () {
        that.downloadImportDisableButton = false
      }, 2000)
    },
    exportExcel(blob, fileName) {
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
      } else { // IE10+下载
        navigator.msSaveBlob(blob, fileName)
      }
    },
    // 编辑结果确定
    edit_sure(data, parentNode) {
      var that = this
      var name = data.name.replace(/\s+/g, '')
      if (data.id) {
        var oldName = this.edit_old_name.replace(/\s+/g, '')
        if (name.length > 0) {
          if (oldName !== name) {
            var params = { id: data.id, name: name }
            updateSemanticManagement(params).then(res => {
              if (res.data.code === 2000) {
                window.qcMessage({ type: 'success', text: res.data.msg })
              } else {
                window.qcMessage({ type: 'warning', text: res.data.msg })
              }
            })
          }
        } else {
          data.name = oldName
        }
      } else {
        if (name.length > 0) {
          saveWordClassGroup(data).then(res => {
            if (res.data.code === 2000) {
              if (!that.$refs.tree.store.nodesMap[data.parentBh]) {
                that.$refs.tree.store.nodesMap[data.parentBh] = parentNode
              }
              data.id = res.data.data
            } else {
              window.qcMessage({ type: 'warning', text: res.data.msg })
              const children = parentNode.data.children || parentNode.data
              const index = children.findIndex(d => d.id === data.id)
              children.splice(index, 1)
              if (children.length === 0) {
                that.$nextTick(() => {
                  that.$refs.tree.store.nodesMap[data.parentBh + 'L'].data.bh = data.parentBh + 'L'
                })
              }
            }
          }).catch(res => {
            window.qcMessage({ type: 'warning', text: '请求错误，请稍后再试' })
          })
        } else {
          const children = parentNode.data.children || parentNode.data
          const index = children.findIndex(d => d.id === data.id)
          children.splice(index, 1)
          if (children.length === 0) {
            that.$nextTick(() => {
              that.$refs.tree.store.nodesMap[data.parentBh + 'L'].data.bh = data.parentBh + 'L'
            })
          }
        }
      }
      data.isEdit = false
    },
    editGroupName(data) {
      var that = this
      if (that.edit_true_bh !== '' && that.$refs.tree.store.nodesMap[that.edit_true_bh]) {
        var node = that.$refs.tree.store.nodesMap[that.edit_true_bh]
        node.data.isEdit = false
      }
      // var data = that.$refs.tree.getCurrentNode()
      if (data == null) {
        window.qcMessage({ type: 'warning', text: '请选择分组！' })
        return false
      }
      if (!data.isEdit) {
        that.$set(data, 'isEdit', true)
        if (data.name) {
          that.edit_old_name = data.name
        }
        that.edit_true_bh = data.bh
        that.$nextTick(() => {
          that.$refs[`${data.bh}`].focus()
        })
      }
    },
    mouseEnter(data) {
      this.$set(data, 'isShow', true)
    },
    mouseLeave(data) {
      this.$set(data, 'isShow', false)
    },
    handleCommand(command) {
      if (command === 'top') {
        this.addTop()
      } else {
        this.$refs[command].$el.click()
      }
    }
  },
  mounted: function () {
    this.queryWordClassGroup(null)
  }
}
</script>

<style scoped>
  .max_box{
    width: 100%;
  }
  .top_box{
    width: 100%;
    height: 100%;
    border-bottom: #e1e3e6 solid 1px;
    padding-top: 12px;
    padding-bottom: 8px;
    margin-bottom: 20px;
  }
  .top_span{
    color: #222;
    font-size: 20px;
    padding-bottom: 10px;
    border-bottom: #0080fe solid 1px;
    padding-right: 5px;
  }
  .el-row {
    margin-bottom: 20px;
  }
  .el-row >>>.el-pagination {
    margin-top: 0px!important;
    margin-bottom: 0px!important;
  }
  .input-title .el-form-item {
     margin-bottom: 0px;
  }
  .el-select {
    display: block!important;
  }
  /*.el-scrollbar >>>.el-scrollbar__wrap {*/
    /*overflow-x: hidden;*/
    /*margin-right: 0px!important;*/
  /*}*/
  .el-tree >>>.el-tree-node {
    display: inline-block;
    overflow-x: hidden;
    min-width: 100%;
    float: left;
  }
  .el-tree .el-tree-node .el-tree-node__content .comp-tr-node{
    width: 90% !important;
  }
  .device-tree{
    height: 100%;
    width: 100%;
  }
  .el-table__body, .el-table__footer, .el-table__header{
    table-layout:auto;
    border-collapse:initial;
  }
  .el-container{
    display: -webkit-box!important;
  }
  .el-table td .el-button + .el-button{
    margin-left: 5px!important;
  }
  .el-breadcrumb{
    padding-top: 0!important;
    margin-left: 30px;
    margin-top: -18px;
    height: 0px;
    line-height: 15px;
    font-size: 16px;
    color: #222222;
    border-bottom: 0px solid #e1e3e6!important;
    box-sizing: border-box;
  }
  .comp-tr-node--name {
    display: inline-block;
    line-height: 30px;
    min-height: 30px;
    width: 85%;
  }
  .el-tree >>>.el-tree-node .el-tree-node__content{
    height: 30px;
  }
  .icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
  .iconwenjianjia-dakai-copy{
    color: #f39d2c;
    font-size: 18px;
  }
  .iconweizhuanwenwenjian{
    color: #c3c9d7;
    font-size: 18px;
  }
  .el-table >>>td{
    padding: 6px 0!important;
    text-align: center;
  }
  .el-main {
    padding: 0px;
  }
  .el-cascader {
    width: 85%;
  }
  .el-table >>> .cell{
    padding-left: 0px;
  }
  .el-tree >>>.el-tree-node.is-current .el-tree-node__content{
    background-color: transparent!important;
  }
  .el-tree--highlight-current >>>.el-tree-node.is-current>.el-tree-node__content {
    background-color: #009eff52!important;
  }
  .el-button--info.is-disabled{
     color: #FFF!important;
     background-color: #c8c9cc!important;
     border-color: #c8c9cc!important;
   }
  .el-button--info {
    background-color: #7bc3fb!important;
    color: #fff!important;
    border: 1px solid #7bc3fb!important; }
  .el-button--info.is-plain.is-disabled, .el-button--info.is-plain.is-disabled:active, .el-button--info.is-plain.is-disabled:focus, .el-button--info.is-plain.is-disabled:hover
  {
    color: #FFF!important;
    background-color: #c8c9cc!important;
    border-color: #c8c9cc!important;
  }
  .el-button--info.is-plain, .el-button--info.is-plain:active, .el-button--info.is-plain:focus, .el-button--info.is-plain:hover
  {
    background-color: #7bc3fb!important;
    color: #fff!important;
    border: 1px solid #7bc3fb!important;
  }
  .el-main >>>.el-breadcrumb .el-breadcrumb__item{
    position: initial!important;
  }
  .el-main >>>.el-breadcrumb .el-breadcrumb__item .el-breadcrumb__inner{
    margin-top: 0px!important;
    float: initial!important;
  }
</style>
